import React, { useState } from "react"

import styles from "./styles.css"

function HeroVideo() {
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className={styles.heroVideo}>
      {isPlaying ? (
        <iframe
          src="https://www.youtube.com/embed/ue8dxw3TziE?autoplay=1&rel=0&mute=0"
          title="Compartilhe energia"
          allow="autoplay"
          allowFullScreen
          loading="lazy"
          className={styles.iframe}
        />
      ) : (
        <button
          type="button"
          className={styles.playButton}
          onClick={() => setIsPlaying(true)}
        >
          <div className={styles.background} />
        </button>
      )}
    </div>
  )
}
export default HeroVideo



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/HeroVideo/index.js